<script setup>
import { storeToRefs } from 'pinia'
import { useEsgStore } from '@/stores/useEsgStore'
import { DETAIL_ESG } from '../../constants'
import EsgAnnexCTable from './esg/EsgAnnexCTable.vue'
import EsgItemComponent from './esg/EsgItemComponent.vue'
import EsgTableComponent from './esg/EsgTableComponent.vue'

const esgStore = useEsgStore()
const { esgData, esgSummary, annexCEnabled } = storeToRefs(esgStore)

const props = defineProps({
  cadasterId: {
    type: String,
    default: null,
  },
})

const items = DETAIL_ESG
</script>

<template>
  <div class="p-2" data-testid="esg-content">
    <div class="grid grid-cols-2 gap-4 mb-4">
      <div v-for="(item, key) in items" :key="`esg-item-${key}`">
        <EsgItemComponent
          v-if="esgData[key]"
          :id="key"
          :item="item"
          :cadaster-id="cadasterId"
          :item-data="esgData[key]"
          v-model:description="esgData[key].user.description"
          v-model:evaluation="esgData[key].user.evaluation"
          v-model:status="esgData[key].user.status"
          @update:description="esgStore.saveEsgData()"
          @update:evaluation="esgStore.saveEsgData()"
          @update:status="esgStore.saveEsgData()"
        />
      </div>
    </div>
    <!-- RED-355: the EVS 875-13 annex C form behind `esg-annex-c`. -->
    <EsgAnnexCTable v-if="annexCEnabled" :value="esgSummary" @change="esgStore.saveEsgData()" />
    <EsgTableComponent v-else :value="esgSummary" @change="esgStore.saveEsgData()" />
  </div>
</template>
